import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatNumberCredit',
    standalone: false
})
export class FormatNumberCreditPipe implements PipeTransform {

  transform(value: string): any {
    return value.replace(/\d(?=\d{4})/g, '*');
  }

}
